import { legacyPlugins } from "/builds/eotlab/eotlab-website/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}